import { HeroCenter } from "../sections/HeroCenter";
import { SimpleFooter } from "../sections/SimpleFooter";
import { ThreeCardDetails } from "../sections/ThreeCardDetails";
import { ImageRow } from "../components/ImageRow";
import { HalfRow } from "../components/HalfRow";

import { BUSINESS_NAME } from "../constants/constants";

import underlay from "../icons/Autumn.svg";
import curvedstripes from "../icons/CurvedStripes.svg";

import hero from "../images/skid01_reverse.jpg";
import first from "../images/exc02.jpg";
import second from "../images/HouseFront.jpg";
import andy from "../images/Andy.jpg";

const Home = () => {
  return (
    <>
      <HeroCenter
        image={hero}
        businessName={BUSINESS_NAME}
        tagline={"Your Trusted Partner for Professional Exterior Cleaning"}
        buttonText={"Contact Us"}
      />
      <section
        className={"flex flex-col items-center justify-center bg-light-100"}
      >
        <HalfRow
          title={"Welcome to our Family"}
          header={BUSINESS_NAME}
          element={
            <div className={"flex flex-col text-pretty"}>
              <p className={"text-md lg:text-xl text-primary-800"}>
                We're proud to be recognized as the Best of the Midwest, and
                even prouder to serve our neighbors with honest work, dependable
                service, and results you can see.
              </p>
              <p className={"text-md mt-2 lg:mt-4 lg:text-xl text-primary-800"}>
                When you choose us, you're not just hiring a power washing
                company—you're joining a family that treats your home and
                business like our own.
              </p>
            </div>
          }
          className={"bg-light-200"}
        />
        <HalfRow
          title={"Keeping Your Space Clean"}
          header={"Premium Power Washing and Exterior Cleaning Services"}
          element={
            <div className={"flex flex-col text-pretty"}>
              <p className={"text-md lg:text-xl text-primary-800"}>
                From homes to businesses, we provide expert power washing and
                exterior maintenance services to keep your property looking its
                best.
              </p>
              <p className={"text-md mt-2 lg:mt-4 lg:text-xl text-primary-800"}>
                American Power Washing & Exterior Services exists to provide top
                tier exterior services and power washing, ensuring the value,
                care, and functionality of our customers' properties.
              </p>
            </div>
          }
          isReversed={true}
          className={"bg-light-100"}
        />
      </section>

      <section
        className={
          "text-pretty text-md md:text-xl md:leading-loose text-primary-800"
        }
      >
        <ImageRow
          image={first}
          underlay={curvedstripes}
          isReversed={false}
          title={"Commercial Services"}
          header={"Powerful Cleaning Solutions for Every Industry"}
          element={
            <div
              className={"flex flex-col pt-6 px-2 items-center md:items-start"}
            >
              <p>
                We provide professional power washing solutions that enhance
                curb appeal, maintain safety, and keep your property looking its
                best.
              </p>
              <ul
                className={
                  "flex flex-col list-[circle] text-left pt-4 md:pl-10"
                }
              >
                {[
                  "Touchless Fleet/Equipment Washing",
                  "Building and Storefront Cleaning",
                  "Drive Thru Cleaning & Degreasing",
                  "Dumpster Pad Cleaning & Degreasing",
                  "Gas Station Cleaning & Degreasing",
                  "Parking Garage Cleaning &Degreasing",
                  "Graffiti Removal",
                ].map((s) => {
                  return <li>{s}</li>;
                })}
              </ul>
            </div>
          }
          className={"pb-8 md:py-16 bg-light-200"}
        />
        <ImageRow
          image={second}
          underlay={curvedstripes}
          isReversed={true}
          title={"Residential Services"}
          header={"A Cleaner Home, A Healthier Environment"}
          element={
            <div
              className={"flex flex-col pt-6 px-2 items-center md:items-start"}
            >
              <p>
                Our professional power washing services safely remove buildup,
                restoring your home's beauty and protecting its longevity.
              </p>
              <ul
                className={
                  "flex flex-col list-[circle] text-left pt-4 md:pl-10"
                }
              >
                {[
                  "House Washing",
                  "Window Cleaning",
                  "Roof and Soffit Cleaning",
                  "Driveway Cleaning",
                  "Deck and Patio Cleaning",
                  "Fence Cleaning",
                ].map((s) => {
                  return <li>{s}</li>;
                })}
              </ul>
            </div>
          }
          className={"pb-8 md:py-16 bg-light-100"}
        />
      </section>

      <ThreeCardDetails />

      <ImageRow
        image={andy}
        underlay={underlay}
        isReversed={false}
        title={"About Us"}
        header={"Meet the Team"}
        element={
          <div
            className={"flex flex-col pt-6 px-2 items-center md:items-start"}
          >
            <p className={"text-md mt-4 md:mt-0 md:text-xl text-primary-800"}>
              American Power Washing and Exterior Services LLC is owned and
              operated by Andrew Eyler.
            </p>
            <p className={"text-md mt-4 md:text-xl text-primary-800"}>
              Andrew started American Power Washing because he wanted to provide
              the best local exterior service cleaning and maintenance. American
              Power Washing is the top choice in exterior cleaning and
              maintenance. Our attention to detail, no matter what the service
              provided is, sets us apart from the competition. From house
              washing, to fleet/equipment washing, and roof cleaning to concrete
              cleaning, residential and commercial, we are your community's
              fully insured choice for power washing.
            </p>
          </div>
        }
        className={"pb-8 md:py-16 bg-light-100"}
      />

      <SimpleFooter backgroundColor={"bg-light-300"} />
    </>
  );
};

export default Home;
